<mat-card class="filter settingHeader">
  <div class="name">
    Manage Email Template
  </div>

  <div class="quickAction">    
      <!-- <mat-form-field class="example-form-field" appearence="fill">
        <mat-label>Search Category</mat-label>
        <input matInput type="text"  readonly  [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
        <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>close</mat-icon>
        </button>
        <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>search</mat-icon>
        </button> -->
      <!-- </mat-form-field> -->
        
        <div class="">      
          <button mat-flat-button color="primary" (click)="openDialogAdd(addmyDialog)"> Add Template </button>   
        </div>
     
  </div>
</mat-card>

<div class="documents">

    <mat-card class="example-list rowholder">
      <div class="fieldRow head">
        <span class="moveicon"></span>       
        <span class="fieldName">Template Name</span>
        <!-- <span class="requried">Active/Inactive</span> -->
        <span class="editField">Edit</span>
        <span class="delete">Delete</span>
      </div>
      <div class="example-box fieldRow" *ngFor="let type of categoryList">
        <span class="moveicon"></span>        
         <span class="fieldName">{{type.emailTemplateName}}</span>  
        <!-- <span class="requried">
          <mat-slide-toggle color="primary"  [disabled]="type.selected"  [checked]="type.isActive" (change)="UpdateStatus(type)">
          </mat-slide-toggle>
        </span>  -->
  
        <span class="editField">
          <button mat-icon-button class="editbtn"  (click)="openDialogUpdateType(addmyDialog,type)">
            <mat-icon>edit</mat-icon>
          </button>
        </span>
  
        <span class="delete">
          <button mat-icon-button class="trash"  (click)="DeleteCategory(type)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </span>
      </div>     
    </mat-card>
    <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>
</div>


<ng-template #addmyDialog>

  <h2 mat-dialog-title>
     {{title}}
      <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
    <mat-label>Template Name</mat-label>
    <input matInput maxlength="100" [required]="true"  
     placeholder="add template name"  [(ngModel)]="templateName"
      />      
</mat-form-field>

  <mat-form-field class="example-full-width">
      <mat-label>Subject</mat-label>
      <input matInput maxlength="100" [required]="true"  
       placeholder="add subject"  [(ngModel)]="subject"
        />      
  </mat-form-field>
 <br>
 <br>
    <div>
      <mat-label>Message</mat-label>
      <ng-container class="cke_notification">
        <ckeditor  [(ngModel)]="msg" [config]="editorConfig"
          editorUrl="https://cdn.ckeditor.com/4.14.0/full/ckeditor.js">
        </ckeditor>
      </ng-container>
    </div>

</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary"  [disabled]="AddEditButton" 
  (click)="AddEmailDetails()">
    {{button}}
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
</mat-dialog-actions>
</ng-template>


<app-loader></app-loader>

<style>
  .cke_notifications_area { display: none;}
</style>


<style>
  .cke_notification { display: none; }
</style>
<style>
  .cke_notification_warning { display: none; }
</style>